// extracted by mini-css-extract-plugin
export default {"container":"BorderedImage_container__r4x+D","image":"BorderedImage_image__WZD0n","letter":"BorderedImage_letter__LR3EH"};